class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		if($(".js-gallery-swiper").length > 0){
			const galleryThumbs = new Swiper(".js-gallery-thum-swiper", {
				spaceBetween: 6,
				slidesPerView: "auto",
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				simulateTouch: false,
				slideToClickedSlide: false,
				breakpoints: {
					768: {
						spaceBetween: 10,
					},
				},
			});
			
			const gallery = new Swiper(".js-gallery-swiper", {
				centeredSlides: true,
				slidesPerView: "auto",
				loop: true,
				spaceBetween: 6,
				navigation: {
					nextEl: ".js-gallery-next",
					prevEl: ".js-gallery-prev",
				},
			
				thumbs: {
					swiper: galleryThumbs,
				},

				// simulateTouch: false,
				// preventClicks: true,
				// preventClicksPropagation: true,
	
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 8,
					},
				},
			});
			
			// document.querySelectorAll('.js-gallery-prev, .js-gallery-next').forEach(el => {
			// 	el.addEventListener('mousedown', (e) => {
			// 		// フォーカスだけ止める（クリックは殺さない）
			// 		if (e.button === 0) {
			// 			document.activeElement.blur();
			// 		}
			// 	});
			// });
		}

		if($(".js-point-swiper").length > 0){
			const pointSwiper = new Swiper(".js-point-swiper", {
				centeredSlides: false,
				slidesPerView: 1.5,
				loop: true,
				loopAdditionalSlides: 2,
				spaceBetween: 12,
				navigation: {
					nextEl: ".js-point-next",
					prevEl: ".js-point-prev",
				},
				breakpoints: {
					768: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
				},
				on: {
					init: function () {
						updateCounter(this);
					},
					slideChange: function () {
						updateCounter(this);
					}
				}
			});

			function updateCounter(swiper) {

				if (window.innerWidth >= 768) return;
			
				const current = swiper.realIndex + 1;
				const total = swiper.el.querySelectorAll(
					'.swiper-slide:not(.swiper-slide-duplicate)'
				).length;
			
				document.querySelector(".js-point-current").textContent =
					String(current).padStart(2, "0");
			
				document.querySelector(".js-point-total").textContent =
					String(total).padStart(2, "0");
			
			}
		}

		if ($(".js-modelhouse-desc-swiper").length > 0) {
			const modelhouseDesc = new Swiper(".js-modelhouse-desc-swiper", {
				slidesPerView: "auto",
				spaceBetween: 10,
				loop: true,
				centeredSlides: true,
				navigation: {
					nextEl: '.js-modelhouse-next',
					prevEl: '.js-modelhouse-prev',
				},
				pagination: {
					el: '.js-modelhouse-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
					},
				},
			});			
		}
		if ($(".js-modelhouse-swiper").length > 0) {

			$(".js-modelhouse-swiper").each(function () {
		
				const $this = $(this);
		
				const swiper = new Swiper(this, {
					centeredSlides: false,
					slidesPerView: 1.1,
					loop: true,
					loopAdditionalSlides: 2,
					spaceBetween: 2,
					navigation: {
						nextEl: $this.find(".js-modelhouse-next")[0],
						prevEl: $this.find(".js-modelhouse-prev")[0],
					},
					pagination: {
						el: '.js-modelhouse-pagination',
						clickable: true,
					},
					breakpoints: {
						768: {
							slidesPerView: 1.5,
							spaceBetween: 4,
						},
					},
		
					on: {
						init: function () {
							updateModelhouseCounter(this, $this);
						},
						slideChange: function () {
							updateModelhouseCounter(this, $this);
						}
					}
		
				});
		
			});
		
			function updateModelhouseCounter(swiper, $el) {
		
				const current = swiper.realIndex + 1;
		
				const total = swiper.el.querySelectorAll(
					'.swiper-slide:not(.swiper-slide-duplicate)'
				).length;
		
				$el.find(".js-modelhouse-current").text(
					String(current).padStart(2)
				);
		
				$el.find(".js-modelhouse-total").text(
					String(total).padStart(2)
				);
		
			}
		
		}

		document.querySelectorAll('.js-view-swiper').forEach(el => {

			if (el.querySelectorAll('.swiper-slide').length === 0) return;
		
			new Swiper(el, {
				slidesPerView: "auto",
				spaceBetween: 2,
				loop: false,
				navigation: {
					nextEl: el.querySelector('.js-view-next'),
					prevEl: el.querySelector('.js-view-prev'),
				},
				pagination: {
					el: el.querySelector('.js-view-pagination'),
					clickable: true,
				},
			});
		
		});

		if($(".js-event-swiper").length > 0){
			const event = new Swiper(".js-event-swiper", {
				slidesPerView: "auto",
				spaceBetween: 10,
				loop: true,
				centeredSlides: true,
				navigation: {
					nextEl: '.js-event-next',
					prevEl: '.js-event-prev',
				},
				pagination: {
					el: '.js-event-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
					},
				},
			});
		}

		if($(".js-works-swiper").length > 0){
			const works = new Swiper(".js-works-swiper", {
				slidesPerView: "auto",
				loop: true,
				loopAdditionalSlides: 2,
				spaceBetween: 10,
				centeredSlides: true,
				speed: 1000,
				navigation: {
					nextEl: '.js-works-next',
					prevEl: '.js-works-prev',
				},
				pagination: {
					el: '.js-works-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 11,
					}
				},
			});
		}

		if($(".js-owner-swiper").length > 0){
			const owner = new Swiper(".js-owner-swiper", {
				slidesPerView: "auto",
				loop: true,
				loopAdditionalSlides: 2,
				spaceBetween: 10,
				centeredSlides: true,
				pagination: {
					el: '.js-owner-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
						centeredSlides: false,
					},
				},
				navigation: {
					nextEl: '.js-owner-next',
					prevEl: '.js-owner-prev',
				},
			});
		}

		if($(".js-blog-swiper").length > 0){
			const blog = new Swiper(".js-blog-swiper", {
				slidesPerView: "auto",
				loop: true,
				spaceBetween: 10,
				centeredSlides: true,
				pagination: {
					el: '.js-blog-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: "auto",
						spaceBetween: 30,
						centeredSlides: false,
					},
				},
				navigation: {
					nextEl: '.js-blog-next',
					prevEl: '.js-blog-prev',
				},
			});
		}
	}
}
